import LTR from "@brand-icons/ploom/pin-other-store-active/pin-other-store-active-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinOtherStoreActiveIcon = iconFactory("PinOtherStoreActiveIcon", LTR);
